<template>
  <v-dialog :model-value="true" :max-width="1400" height="100%" @update:model-value="$emit('close')">
    <v-card class="py-6 px-10 bg-background">
      <v-btn-icon color="darkgrey" style="position: absolute; top: 4px; right: 4px" @click="$emit('close')">
        <v-icon size="large">far fa-times</v-icon>
      </v-btn-icon>
      <div v-if="! planning">
        <div class="d-flex align-center">
          <b class="text-h6">{{ project.title || $t('PLANNING.UNNAMED_PROJECT') }}</b>
        </div>
        <div class="text-center py-12"><i class="far fa-spinner fa-spin fa-2x fa-fw"></i></div>
      </div>
      <div v-else>
        <div class="d-flex align-center gap-4 mb-2">
          <b class="text-h6">{{ project.title || $t('PLANNING.UNNAMED_PROJECT') }}</b>
          <v-select v-model="openedTabIndex" :items="projectReportTabs" item-title="label" item-value="id" density="compact" style="max-width: 300px"></v-select>
        </div>
        <project-report-windows v-model:opened-tab-index="openedTabIndex" :planning="planning"
                                @open-project-report="openedTabIndex = $event" @update="updateProjectSheet" @reload-planning="loadPlanning()">
        </project-report-windows>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
  import clientConfig from '@/client_customs/config';
  import { hasAccessToPremiumFeature } from '@/components/Premium/PremiumFeatures';
  import ProjectSrv from '@/components/Projects/ProjectSrv';
  import Planning from '@/models/Planning';
  import ProjectReportWindows from '@/components/ProjectReport/ProjectReportWindows.vue';

  export default {
    components: {
      ProjectReportWindows,
    },
    props: {
      project: { type: Object, required: true },
      readonly: { type: Boolean, default: false },
    },
    emits: ['update', 'close'],
    data() {
      return {
        planning: null,
        customTabs: clientConfig.projectsheet?.customTabs,
        openedTabIndex: 'projectsheet',
      };
    },
    computed: {
      projectReportTabs() {
        return [
          { id: 'projectsheet', icon: 'far fa-flag', label: this.$t('PROJECT_SHEET.PROJECT_SHEET') },
          ...(this.customTabs || []),
          { id: 'files', icon: 'far fa-paperclip', label: this.$t('PROJECT_SHEET.FILES') },
          { id: 'budget', icon: 'far fa-euro-sign', label: this.$t('PROJECT_SHEET.BUDGET') },
          { id: 'users', icon: 'far fa-user', label: this.$t('PROJECT_SHEET.USERS') },
          { id: 'risks', premiumFeature: 'risks', icon: 'far fa-square-exclamation', label: this.planning?.projectsheet?.risks?.title || this.$t('PROJECT_SHEET.RISKS.TITLE') },
        ].filter(tab => ! tab.premiumFeature || hasAccessToPremiumFeature(tab.premiumFeature)); // exclude tabs if user doesn't have access
      },
    },
    watch: {
      project: {
        handler() {
          this.loadPlanning();
        },
        immediate: true,
      },
    },
    methods: {
      loadPlanning() {
        ProjectSrv.get(this.project.id).then((content) => {
          this.planning = new Planning(content);
          if (this.readonly) this.planning.meta.access_right = 'consult';
        });
      },
      updateProjectSheet(values) {
        _.extend(this.planning.projectsheet, values);
        this.planning.saveAdmin({ projectsheet: this.planning.projectsheet });
        this.$emit('update', values);
      },
      close() {
        if (this.planning) {
          this.project.category = this.planning.meta.category;
          this.project.imgurl = this.planning.meta.imgurl;
        }
        this.$emit('close');
      },
    },
  };
</script>
